export default __webpack_public_path__ + "static/media/Alarme.04641e08.svg";